import type { ImageDto } from '@sbg/shared/schemas';
import { Picture } from '@/components/media';

export interface TextureProbeProps {
  image: ImageDto;
  /** The URL the browser actually chose from the AVIF / WebP / JPEG set. */
  onResolve: (url: string) => void;
  onError: () => void;
}

/**
 * Loads a stone's seamless tile through the normal `<picture>` machinery, so the browser itself picks
 * the best format it can decode (AVIF, then WebP, then JPEG) and the download is the one request the
 * CSS background will reuse. It is invisible and takes no space; its `load` event is the "the texture
 * is ready" signal, and `currentSrc` is the URL to paint with.
 */
export function TextureProbe({ image, onResolve, onError }: TextureProbeProps) {
  return (
    <div className="viz-probe" aria-hidden="true">
      <Picture
        image={image}
        alt=""
        sizes="768px"
        priority
        onLoad={(event) => {
          const { currentSrc, src } = event.currentTarget;
          onResolve(currentSrc || src);
        }}
        onError={onError}
      />
    </div>
  );
}
